// extracted by mini-css-extract-plugin
export default {"card":"M6-z"};